<a mat-flat-button [class]="classList" color="primary" [href]="wizardUrl">
	<ng-content></ng-content>
</a>
